/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Accordian JS 
document.addEventListener('DOMContentLoaded', function () {
  const accordion = document.getElementById('accordionExample');
  if (!accordion) return;

  const buttons = accordion.querySelectorAll('.accordion-button');
  buttons.forEach((button) => {
    const isOpen = button.getAttribute('aria-expanded') === 'true';
    const targetId = button.getAttribute('aria-controls');
    const target = document.getElementById(targetId);

    if (isOpen && target) {
      target.classList.add('is-open');
    } else if (target) {
      target.classList.remove('is-open');
    }
  });

  buttons.forEach((button) => {
    button.addEventListener('click', function () {
      const isOpen = this.getAttribute('aria-expanded') === 'true';
      const targetId = this.getAttribute('aria-controls');
      const target = document.getElementById(targetId);

      buttons.forEach((btn) => {
        btn.setAttribute('aria-expanded', 'false');
        const panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.classList.remove('is-open');
      });

      if (!isOpen && target) {
        this.setAttribute('aria-expanded', 'true');
        target.classList.add('is-open');
      }
    });
  });
});



(function () {
  function forceQuantity() {
    const dropdown = document.querySelector('#custom-qty');
    const input = document.querySelector('input[name="quantity"]');

    if (!dropdown || !input) return;
    input.value = dropdown.value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    console.log('Quantity synced:', dropdown.value);
  }

  function init() {
    setTimeout(forceQuantity, 300);
    setTimeout(forceQuantity, 800);
    setTimeout(forceQuantity, 1500);
  }
  document.addEventListener('change', function(e) {
    if (e.target.id === 'custom-qty') {
      forceQuantity();
    }
  });
  document.addEventListener('click', function(e) {
    if (e.target.closest('[type="submit"], .product-form__submit')) {
      forceQuantity();
    }
  });

  let lastUrl = location.href;

  setInterval(() => {
    if (location.href !== lastUrl) {
      lastUrl = location.href;
      console.log('Page changed → re-init quantity');

      setTimeout(init, 500); // wait for YMQ render
    }
  }, 500);
  window.addEventListener('load', init);
})();
